import { convertOptionsToAutoComplete } from '../../../utils/convertOptionsToAutoCompleteOptions';

export type TravelFileTypes = 'group' | 'client';
export type TravelFileTypesKeys = 'GROUP' | 'CLIENT';
export const travelFileTypesEnum: {
    [key in TravelFileTypesKeys]: TravelFileTypes;
} = {
    GROUP: 'group',
    CLIENT: 'client'
};
export const travelFileTypesOptions = Object.values(travelFileTypesEnum) as TravelFileTypes[];

export const TRAVEL_FILE_TYPES_OPTIONS_AND_ID = convertOptionsToAutoComplete(travelFileTypesOptions);
